<template>
    <div class="offerContacts ben-fff-bg">
        <div class="title ben-border-t">
            <span class="ben-000-color ben-size-15 ben-text-bold">联系信息</span>
        </div>
        <div class="contact-comm">
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">联系人</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <div class="title-right-comm">
                        <van-field v-model="userName" placeholder="请输入联系人" @input="changeName"/>
                    </div>
                </van-col>
            </van-row>
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">联系电话</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <div class="title-right-comm">
                        <van-field v-model="phone" placeholder="请输入联系电话" type="digit" maxlength='11' @input="changePhone"/>
                    </div>
                </van-col>
            </van-row>
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">QQ</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <div class="title-right-comm">
                        <van-field v-model="userqq" placeholder="(非必填项)请输入联系人QQ号" type="digit" maxlength='11'  @input="changeqq"/>
                    </div>
                </van-col>
            </van-row>
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">电子邮箱</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <div class="title-right-comm">
                        <van-field v-model="usermeil" placeholder="(非必填项)请输入联系人邮箱" @input="changeEmail"/>
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    name:'offerContacts',
    props : {
        data : {
            type : Object
        }
    },
    components: {
    },
    data () {
        return {
            userName : "",
            phone : "",
            userqq : "",
            usermeil : '',
            dataObj:{
                offer_email : "",
                offer_name : "",
                offer_phone : "",
                offer_qq : ""
            }
        }
    },
    created () {
        
    },
    methods: {
        changeName(e){
            this.dataObj.offer_name = e
            this.$emit("setOfferContacts",this.dataObj)
        },
        changePhone(e){
            this.dataObj.offer_phone = e
            this.$emit("setOfferContacts",this.dataObj)

        },
        changeqq(e){
            this.dataObj.offer_qq = e
            this.$emit("setOfferContacts",this.dataObj)
        },
        changeEmail(e){
            this.dataObj.offer_email = e
            this.$emit("setOfferContacts",this.dataObj)
        }
        
    },
    mounted () {
        let userinfo = JSON.parse(localStorage.getItem('userinfo'))
        if(userinfo.tails&&userinfo.tails.contacts&&userinfo.tails.contacts[0].contacter){
            this.userName = userinfo.tails.contacts[0].contacter;
            this.changeName(this.userName);
        }
        if(userinfo.tails&&userinfo.tails.contacts&&userinfo.tails.contacts[0].phone){
            this.phone = userinfo.tails.contacts[0].phone
            this.changePhone(this.phone)
        }
        if(userinfo.tails&&userinfo.tails.contacts&&userinfo.tails.contacts[0].email){
            this.usermeil = userinfo.tails.contacts[0].email
            this.changeEmail(this.usermeil)
        }
    },
}

</script>


<style lang='scss' scoped>
.offerContacts{
    margin-top: 5px;
    .van-cell{
        padding: 0;
    }
    .info-list-comm{
        margin:0 15px ;
        padding: 15px 0;
    }
    .title{
        padding: 20px 15px 10px 15px;
        >span{
            border-bottom: 3px solid #C41335;
            padding-bottom: 10px;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerContacts.vue